import React from 'react'
import { clickableProps } from '../utils/clickableProps'

const AddEventCard = ({ onAddEvent }) => {
  return (
    <div
      {...clickableProps(onAddEvent, 'Add a new event')}
      className="group relative bg-white/5 backdrop-blur-xl rounded-3xl shadow-2xl border-2 border-dashed border-white/30 hover:border-white/50 overflow-hidden hover:scale-105 hover:shadow-3xl transition-all duration-300 cursor-pointer flex flex-col justify-center items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-400"
      style={{
        aspectRatio: '3/4',
        minHeight: '240px'
      }}
    >
      <div className="text-center">
        <div className="w-12 h-12 bg-purple-600/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
          <svg className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </div>
        <p className="text-white font-medium text-sm mb-1">Add Event</p>
        <p className="text-gray-300 text-xs px-2">Create a new event</p>
      </div>
    </div>
  );
};

export default AddEventCard